
function CLAIM_TYPE( id ){
  if(id == '1') {
    return 'ค่าแรง ค่าอะไหล่'
  } else if(id == '2') {
    return 'ค่ารถยก'
  } else if(id == '3') {
    return 'ค่ายาง ค่าล้อแม็ก'
  } else if(id == '4') {
    return 'ค่ากระจก ค่าฟิล์ม'
  } else if(id == '5') {
    return 'ค่าแรง ค่าอะไหล่ ค่ารถยก'
  } else if(id == '6') {
    return 'ค่าแรง ค่าอะไหล่'
  } else if(id == '7') {
    return 'ค่าแรง ค่าอะไหล่ ค่าขาดผลประโยชน์'
  } else if(id == '8') {
    return 'ค่าแรง ค่าอะไหล่ ค่าขาดผลประโยชน์ ค่ารถยก'
  } else if(id == '9') {
    return 'ค่าขาดผลประโยชน์'
  } else if(id == '10') {
    return 'ค่าขาดผลประโยชน์ ค่ารถยก'
  } else if(id == '11') {
    return 'ค่ารถยก'
  } else if(id == '13') {
    return 'ค่ากระจก ค่าฟิล์ม'
  } else if(id == '12') {
    return 'ค่ายาง ค่าล้อแม็ก'
  }
  return id
}


function CLAIM_TYPES( suffererType ){
  //    คู่กรณี
  if (suffererType != 0) {
    return [
      {
        id: '6',
        description: 'ค่าแรง ค่าอะไหล่'
      },
      {
        id: '7',
        description: 'ค่าแรง ค่าอะไหล่ ค่าขาดผลประโยชน์'
      },
      {
        id: '8',
        description: 'ค่าแรง ค่าอะไหล่ ค่าขาดผลประโยชน์ ค่ารถยก'
      },
      {
        id: '9',
        description: 'ค่าขาดผลประโยชน์'
      },
      {
        id: '10',
        description: 'ค่าขาดผลประโยชน์ ค่ารถยก'
      },
      {
        id: '11',
        description: 'ค่ารถยก'
      },
      {
        id: '12',
        description: 'ค่ายาง ค่าล้อแม็ก'
      },
      {
        id: '13',
        description: 'ค่ากระจก ค่าฟิล์ม'
      },
    ]
  } else {
    // ประกัน
    return [
      {
        id: '1',
        description: 'ค่าแรง ค่าอะไหล่'
      },

      {
        id: '5',
        description: 'ค่าแรง ค่าอะไหล่ ค่ารถยก'
      },
      {
        id: '2',
        description: 'ค่ารถยก'
      },
      {
        id: '3',
        description: 'ค่ายาง ค่าล้อแม็ก'
      },
      {
        id: '4',
        description: 'ค่ากระจก ค่าฟิล์ม'
      },
    ]
  }
}

export { CLAIM_TYPE, CLAIM_TYPES }